import { getEnvironmentConfig, type EnvironmentConfig } from './environments';
import { API_PATHS } from './api.config';

export type ConfigKey = keyof EnvironmentConfig | keyof typeof API_PATHS | `services.${keyof EnvironmentConfig['services']}`;

class Config {
  private static instance: Config;
  private envConfig: EnvironmentConfig;

  private constructor() {
    this.envConfig = getEnvironmentConfig();
  }

  public static getInstance(): Config {
    if (!Config.instance) {
      Config.instance = new Config();
    }
    return Config.instance;
  }

  public get<T = string>(key: ConfigKey): T {
    // Handle nested services keys
    if (key.startsWith('services.')) {
      const serviceKey = key.replace('services.', '') as keyof EnvironmentConfig['services'];
      return this.envConfig.services[serviceKey] as T;
    }

    // Check API_PATHS first
    if (key in API_PATHS) {
      return API_PATHS[key as keyof typeof API_PATHS] as T;
    }

    // Then check environment config
    if (key in this.envConfig) {
      return this.envConfig[key as keyof EnvironmentConfig] as T;
    }

    throw new Error(`Config key "${key}" not found`);
  }

  public getAll(): EnvironmentConfig & typeof API_PATHS {
    return {
      ...this.envConfig,
      ...API_PATHS,
    };
  }

  public reload(): void {
    this.envConfig = getEnvironmentConfig();
  }
}

export const config = Config.getInstance();
export default config;

export * from './environments';
export * from './api.config';
